module.exports = __webpack_public_path__ + "01bb7a35b33f399b95940d7bf52bf37d.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/Lato-LightItalic.ttf
// module id = 973
// module chunks = 0